/** Mesmas 4 coberturas de diária do Vida PME gravadas no back. */
const DAILY_BENEFIT_COVERAGE_CODES = new Set([
  '8200014',
  '9300005',
  '8200015',
  '9300004',
]);

export function isDailyBenefitCoverage(code: string | null | undefined): boolean {
  return DAILY_BENEFIT_COVERAGE_CODES.has(String(code ?? '').trim());
}
